import { render, staticRenderFns } from "./ThgDialogYearSelection.vue?vue&type=template&id=b34b85e8"
import script from "./ThgDialogYearSelection.vue?vue&type=script&lang=ts"
export * from "./ThgDialogYearSelection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports